import script from "./BenchmarkTableCel.vue?vue&type=script&setup=true&lang=ts"
export * from "./BenchmarkTableCel.vue?vue&type=script&setup=true&lang=ts"

import "./BenchmarkTableCel.vue?vue&type=style&index=0&id=5066ad3e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5066ad3e"]])

export default __exports__